/**
 * A `Set`, with one item's membership flipped — immutable, so it drops straight into `useState`.
 * The inbox's checkboxes and the push modal's environment checklist both used to hand-roll this.
 */
export const toggled = <T>(set: ReadonlySet<T>, item: T): Set<T> => {
    const next = new Set(set);
    if (next.has(item)) next.delete(item);
    else next.add(item);
    return next;
};
